import React, { useState } from "react";
import { Check, Loader2 } from "lucide-react";
import { card, h2 } from "@/components/portal/lp/lpApi";

export function TrackPhases({ d, testid = "vt-phases" }) {
  return (
    <section className={`${card} space-y-2`} data-testid={testid}>
      <h2 className={h2}>{d.selected.name} · {d.completed}/4 phases</h2>
      <ol className="space-y-1.5 text-sm">
        {d.phases.map((p) => (
          <li key={p.phase} data-testid={`${testid}-${p.phase}`} className={`flex gap-2 ${p.done ? "text-white/40" : ""}`}>
            <span className={p.done ? "text-emerald-300" : "text-[#d4a017]"}>{p.done ? "✓" : `${p.phase}.`}</span>
            <span><span className={p.done ? "line-through" : ""}>{p.title}</span> <span className="text-xs text-white/40">· {p.detail}</span></span>
          </li>
        ))}
      </ol>
    </section>
  );
}

export default function VocationTrackPicker({ d, onPick }) {
  const [busy, setBusy] = useState(null);
  const [error, setError] = useState(null);
  const pick = async (id) => {
    if (d.selected && !window.confirm("Switch your vocation track? Your phase progress on the current track starts over.")) return;
    setBusy(id); setError(null);
    try { await onPick(id); } catch (e) { setError(e?.response?.data?.detail || "Couldn't save. Please try again."); } finally { setBusy(null); }
  };
  return (
    <div className="space-y-4" data-testid="vt-picker">
      {d.selected ? <TrackPhases d={d} /> : <p data-testid="vt-none" className="text-sm text-white/60">Pick the career you want to build toward. Your case manager will track your progress through its 4 phases.</p>}
      {error && <p data-testid="vt-error" className="text-sm text-red-300">{error}</p>}
      {d.catalog.map((c) => (
        <section key={c.category} className="space-y-2">
          <h2 className={h2}>{c.category}</h2>
          {c.tracks.map((t) => {
            const on = d.selected?.id === t.id;
            return (
              <button key={t.id} type="button" onClick={() => !on && pick(t.id)} disabled={!!busy} data-testid={`vt-option-${t.id}`}
                className={`w-full flex items-center gap-3 rounded-md border p-3 text-left text-sm transition-colors ${on ? "border-[#d4a017] bg-[#d4a017]/10 text-white" : "border-white/10 text-white/85 hover:border-white/30"}`}>
                <span className="flex-1">{t.name}</span>
                {busy === t.id ? <Loader2 className="h-4 w-4 animate-spin" /> : on && <Check data-testid={`vt-selected-${t.id}`} className="h-4 w-4 text-[#d4a017]" />}
              </button>
            );
          })}
        </section>
      ))}
    </div>
  );
}
